export default "__VITE_ASSET__Zuil3Xsh__"